module.exports = __webpack_public_path__ + "img/1728609701777-Screenshot_11-10-2024_92129_www.instagram.com.jpeg.8748b9ad.webp";